import { SETTING_KEYS } from "../constants/settings";
import {
    getSetting,
    setSetting,
} from "../../common/helpers/settingStorageHelpers";
import { getSettingsWithNoFilter } from "../../calendar-common/helpers/settingsHelper";

export const saveNotificationSoundOn = (store, actualValue) => {
    const { settings } = store.getState();

    store.setState({
        settings: {
            ...settings,
            notificationSoundOn: actualValue,
        },
    });
};
export const saveSettings = (store, actualSettings) => {
    const { settings } = store.getState();

    store.setState({
        settings: {
            ...settings,
            ...actualSettings
        },
    });
};
export const updateSettingsFromStorage = (store) => {

    let storageSettings = getSettingsWithNoFilter();
    const { settings } = store.getState();
    
    let newSettings = {...settings, ...storageSettings}
    store.setState({ settings: newSettings });
    
};